import React from 'react'

function ContactPage() {
  return (
    <div className="bg-gray-50">
      <main>
          <div className="subpage-hero h-96 md:96 relative">
              
          </div>
      </main>

        <section className="text-center -mt-28 sm:text-left md:px-6 py-1 lg:max-w-screen-2xl mx-auto relative">
        <h1 className="text-3xl mx-4 mb-2 pb-2 pt-4 text-white">Contact</h1>
        <div className="p-8 m-4 mb-4 bg-white rounded-sm drop-shadow">
        
        </div>
        
      </section>
      
    </div>
  )
}

export default ContactPage